import { render, staticRenderFns } from "./myCollections.vue?vue&type=template&id=36de8cd6&scoped=true"
import script from "./myCollections.vue?vue&type=script&lang=js"
export * from "./myCollections.vue?vue&type=script&lang=js"
import style0 from "./myCollections.vue?vue&type=style&index=0&id=36de8cd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36de8cd6",
  null
  
)

export default component.exports